import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withShowHidePassword from 'components/common/hoc/withShowHidePassword/withShowHidePassword'
import Rules from 'components/common/Rules/Rules'
import { ShowHidePasswordField } from 'components/common/Fields'
import Media from 'components/common/Media'
import * as UI from './FormStyles'

const renderShowHidePass = withShowHidePassword({ name: 'registration-password' })(ShowHidePasswordField)

const Passwords = ({ form, rules, values, isPasswordFieldActive, ...props }) =>
  <UI.Row>
    <UI.Cell>
      <Field
        data-at-createaccountform-password-input
        { ...props }
        { ...form.password }
        full
        static
        component={ renderShowHidePass } />
      <Media.Mobile>
        <Rules
          margin="8px 0 17px"
          active={ isPasswordFieldActive }
          dirty={ !!values[form.password.name] }
          rules={ rules }
          values={ values } />
      </Media.Mobile>
      <Field
        data-at-createaccountform-confirmpassword-input
        { ...props }
        { ...form.confirmPassword }
        full
        static
        component={ renderShowHidePass } />
    </UI.Cell>
    <Media.Desktop>
      <UI.Cell>
        <Rules
          margin="0"
          active={ isPasswordFieldActive }
          dirty={ !!values[form.password.name] }
          rules={ rules }
          values={ values } />
      </UI.Cell>
    </Media.Desktop>
  </UI.Row>

Passwords.propTypes = {
  form: PropTypes.shape({
    password: PropTypes.shape({
      name: PropTypes.string
    }),
    confirmPassword: PropTypes.shape()
  }),
  isPasswordFieldActive: PropTypes.bool,
  rules: PropTypes.arrayOf(PropTypes.object),
  values: PropTypes.shape()
}

export default Passwords
